/// <amd-module name="Core/Medius.Core.Web/Scripts/Bifrost/embedding"/>

export const getEmbeddableUrlIfNeeded = (prefix: string) => {
    const currentUrl = window.location.href;
    return currentUrl.includes("SupplierInvoicesInbox") 
        ? "SupplierInvoicesInbox" + prefix 
        : prefix;
};
